
import { SgInfiniteScroll } from '@sgui-plus/components/infinite-scroll'
import { SgLoading } from '@sgui-plus/components/loading'
import { SgMessage } from '@sgui-plus/components/message'
import { SgModal } from '@sgui-plus/components/modal'
import { SgNotification } from '@sgui-plus/components/notification'

import type { Plugin } from 'vue'

export default [
  SgInfiniteScroll,
  SgLoading,
  SgMessage,
  SgModal,
  SgNotification
] as Plugin[]
